import React, { Fragment, useState, useEffect, useRef } from "react";
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormGroup,
  Form,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import DatePicker from "react-datepicker";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import DataTable from "react-data-table-component";
import { H3, Btn, Breadcrumbs, H4 } from "../../AbstractElements";
import { Link, useNavigate } from "react-router-dom";
import {
  deleteAccount,
  getAccount,
  getNotificationCreditReport,
  getpackageselect,
  packageReport,
} from "../../CommonURL";
import { getDataWithToken, postDataWithToken } from "../../Utils/restUtils";
import { Add, PaymentStatus, Status } from "../../Constant";
import SearchList from "../../CommonElements/Search";
import Transparentspinner from "../Common/loader/Transparentspinner";
import IndustryFilter from "../Common/Filters/IndustryFilter";
import { invoicePaymentOptions, paymentStatusOptions } from "../../Constant/DropdownValue";
import CompanyFilter from "../Common/Filters/CompanyFilter";
import UserFilter from "../Common/Filters/UserFilter";

const NotifiactionCredit = () => {
  const style2 = { width: 60, fontSize: 13, padding: 3, marginRight: "10px" };
  const toggleStyle = {
    padding: "10px 20px",
    opacity: "0.8",
    fontSize: "14px",
  };

  const [appliedFilters, setAppliedFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [packData, setPackData] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [tempSearch, setTempSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchResetKey, setSearchResetKey] = useState(0);
  const [selectedPackage, setSelectedPackage] = useState("");
  const [packageOptions, setPackageOptions] = useState([]);
  const [isIndustry, setIsIndustry] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const [isCompany, setIsCompany] = useState(null);
  const [dateRange, setDateRange] = useState([]);
  const [startDate, endDate] = dateRange;

  const navigate = useNavigate();
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const isStatus = useRef(null);
  const NotificationCreditColumns = [
    {
      name: <H4>Sl No</H4>,
      selector: (row) => row.Sl,
      sortable: true,
      width: "80px",
      center:true
    },
    {
      name: <H4>User Name</H4>,
      selector: (row) => (
      <Link
        to={`${process.env.PUBLIC_URL}/subscriptions/company-list/userProfile?id=${row.User_id}`}
      >
        {row.UserName}
      </Link>
    ),
      sortable: true,
      width: "150px",
    },
     {
      name: <H4>Industry</H4>,
      selector: (row) => row.Industry,
      sortable: true,
      width: "150px",
      wrap: true,
    },
    {
        name: <H4>Company Name</H4>,
        selector: (row) => (
          <Link
            to={`${process.env.PUBLIC_URL}/subscriptions/companyProfile?id=${row.company_id}&user_id=${row.User_id}&industryId=${row.industryTypeId}`}
            state={{
              clientUrl: row.client_url,
              industryName: row.Industry,
            }}
          >
            {row.Company}
          </Link>
        ),
        sortable: true,
        width: "190px",
        wrap: true,
      },
   
    
    {
      name: <H4>Credit Amount</H4>,
       selector: (row) => (
      <span className=" fw-bolder billerq_color">₹ {row.CreditAmount}</span>
    ),
      sortable: true,
      width: "150px",
    },
     {
      name: <H4>Transaction Date</H4>,
      selector: (row) => row.PaymentDate,
      sortable: true,
      width: "150px",
      wrap: true,
    },
   {
       name: <H4>Invoice No</H4>,
       id: "invoice_number",
       selector: (row) => (
         <Link
           to={`${process.env.PUBLIC_URL}/companies/company-list/userProfile/invoice?id=${row.User_id}&order_id=${row.Id}`}
         >
           {row.InvoiceNumber}
         </Link>
       ),
       sortable: true,
       width: "100px",
       wrap: true,
     },
 {
      name: <H4>Transaction ID</H4>,
      selector: (row) => row.TransactionId,
      sortable: true,
      width: "150px",
      wrap: true,
    },
   
    {
      name: <H4>Payment Status</H4>,
      selector: (row) => row.PaymentStatus,
      sortable: true,
      width: "150px",
    },
  ];

  useEffect(() => {
    notificationData();
  }, []);

  const updateSearchKeyword = (keyword) => {
    setTempSearch(keyword);
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
    notificationData(page, perPage, appliedFilters);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    notificationData(page, newPerPage, appliedFilters);
  };
  const handleFilter = () => {
    const filters = {
      search: tempSearch,
      industry_type_id: isIndustry?.value || "",
      company_id: isCompany?.value || "",
      payment_status: isStatus.current?.value || "",
      start_date: startDate ? startDate.toISOString().split("T")[0] : "",
      end_date: endDate ? endDate.toISOString().split("T")[0] : "",
    };

    setAppliedFilters(filters);
    setCurrentPage(1);
    notificationData(1, perPage, filters);
  };
  const notificationData = async (page = 1, size = perPage, filters = {}) => {
    setLoading(true);
    try {
      const query = new URLSearchParams({
        page,
        page_length: size,
        search: filters.search || "",
        industry_type_id: filters.industry_type_id || "",
        company_id: filters.company_id || "",
        payment_status: filters.payment_status || "",
        start_date: filters.start_date || "",
        end_date: filters.end_date || "",
      }).toString();

      const res = await getDataWithToken(
        `${getNotificationCreditReport}?${query}`,
      );

      const formattedData = res.data.data.map((e, index) => ({
        Sl: (page - 1) * size + index + 1,
        TransactionId: e.transaction_id,
        Industry: e.industry_name,
        Company: e.company_name,
        UserName: e.user_name,
        PaymentStatus: e.payment_status,
        CreditAmount: e.credit_amount,
        PaymentDate: e.payment_date,
        InvoiceNumber: e.invoice_number,
        Id:e.order_id,
        User_id:e.user_id,
        company_id:e.company_id,
        client_url:e.client_url,
        industryTypeId:e.industry_id,
      }));

      setPackData(formattedData);
      setTotalRows(res.data.total || 0);
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  };
  const fetchExportData = async () => {
  const query = new URLSearchParams({
    export: "notification_credit_report",
    search: appliedFilters.search || "",
    industry_type_id: appliedFilters.industry_type_id || "",
    company_id: appliedFilters.company_id || "",
    payment_status: appliedFilters.payment_status || "",
    start_date: appliedFilters.start_date || "",
    end_date: appliedFilters.end_date || "",
  }).toString();

  const res = await getDataWithToken(
    `${getNotificationCreditReport}?${query}`
  );

  return res?.data || [];
};
const exportExcel = async () => {
  setLoading(true);
  try {
    const data = await fetchExportData();

    const formatted = data.map((e, index) => ({
      Sl: index + 1,
      User: e.user_name,
      Industry: e.industry_name,
      Company: e.company_name,
      Invoice: e.invoice_number,
      Credit: e.credit_amount,
      TransactionId: e.transaction_id,
      Date: e.payment_date,
      Status: e.payment_status,
    }));

    const ws = XLSX.utils.json_to_sheet(formatted);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Notification Credit Report");

    XLSX.writeFile(wb, "notification_credit_report.xlsx");
  } catch (err) {
    console.log(err);
  }
  setLoading(false);
};
const exportPDF = async () => {
  setLoading(true);
  try {
    const data = await fetchExportData();

    const doc = new jsPDF();

    const rows = data.map((e, index) => [
      index + 1,
      e.user_name,
      e.industry_name,
      e.company_name,
      e.invoice_number,
      e.credit_amount,
      e.transaction_id,
      e.payment_date,
      e.payment_status,
    ]);

    autoTable(doc, {
      head: [[
        "Sl",
        "User",
        "Industry",
        "Company",
        "Invoice",
        "Credit",
        "Transaction ID",
        "Date",
        "Status",
      ]],
      body: rows,
    });

    doc.save("notification_credit_report.pdf");
  } catch (err) {
    console.log(err);
  }
  setLoading(false);
};
  return (
    <Fragment>
      {loading && <Transparentspinner />}
      <Breadcrumbs
        mainTitle="Notification Credit Payment "
        parent="Report"
        title="Notification Credit Payment"
      />
      <Card>
        <CardHeader className="d-flex justify-content-between align-items-center">
  <H3>Notification Credit Payment Report</H3>

  <Dropdown isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)}>
    <DropdownToggle
      className="btn btn-primary"
      color="#fff" style={{ fontSize: '14px', zIndex: 1000 }}
      
    >
      Export <i className="icofont icofont-arrow-up"></i>
    </DropdownToggle>

    <DropdownMenu container="body">
      <DropdownItem onClick={exportExcel}>
        <i className="fa fa-file-excel-o me-2"></i> Excel
      </DropdownItem>

      <DropdownItem onClick={exportPDF}>
        <i className="fa fa-file-pdf-o me-2"></i> PDF
      </DropdownItem>
    </DropdownMenu>
  </Dropdown>
</CardHeader>
        <div
          style={{
            paddingLeft: "22px",
            marginRight: "22px",
            marginBottom: "-20px",
          }}
        >
          <div className="px-4 pb-2">
            <Row className="g-3 align-items-center">
              <Col sm="12" md="5" lg="3" className="pt-3">
                <SearchList
                  className="form-control"
                  key={searchResetKey}
                  updateSearchKeyword={updateSearchKeyword}
                  // onEnter={handleFilter}
                />
              </Col>
              <Col sm="12" md="6" lg="3">
                <IndustryFilter
                  IsIndustry={isIndustry}
                  setIsIndustry={setIsIndustry}
                />
              </Col>
             
              <Col sm="12" md="5" lg="3" className="form-element">
                <CompanyFilter
                  IsCompany={isCompany}
                  setIsCompany={setIsCompany}
                  industryId={isIndustry?.value}
                />
              </Col>

              <Col sm="12" md="5" lg="3">
                <div style={{ position: "relative" }}>
                  <DatePicker
                    className="form-control digits w-100"
                    selectsRange
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => setDateRange(update)}
                    isClearable={!!(startDate || endDate)}
                    monthsShown={2}
                    calendarClassName="parallel-calendar"
                    placeholderText="Select Date Range"
                    dateFormat="dd-MM-yyyy"
                  />
                </div>
              </Col>
              <Col sm="12" md="5" lg="2" className="form-element">
                <select
                  className="form-select"
                  ref={isStatus}
                  
                >
                  <option value="">{PaymentStatus}</option>
                  {invoicePaymentOptions.map((option, index) => (
                    <option key={index} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </Col>
              <Col>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    float: "left",
                    gap: "10px",
                  }}
                >
                  <button
                    className="btn btn-primary mb-2 ms-2"
                    onClick={handleFilter}
                  >
                    Filter
                  </button>
                </div>
              </Col>
            </Row>
          </div>
          
          <div style={{ clear: "both" }}></div>
        </div>
        <CardBody>
          <div className="order-history table-responsive">
            <DataTable
              columns={NotificationCreditColumns}
              data={packData}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handlePerRowsChange}
              paginationPerPage={10}
              paginationRowsPerPageOptions={[10, 25, 50, 100]}
            />
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default NotifiactionCredit;
